import { render } from "./PostsToolbar.vue?vue&type=template&id=005c0254&ts=true"
import script from "./PostsToolbar.vue?vue&type=script&lang=ts"
export * from "./PostsToolbar.vue?vue&type=script&lang=ts"

import "./PostsToolbar.vue?vue&type=style&index=0&id=005c0254&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QBtnGroup from 'quasar/src/components/btn-group/QBtnGroup.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBtnGroup,QBtn});
